"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeisureReviewPhotoListPageRequestSchema = exports.LeisureReviewPhotoListPageQuery = exports.LeisureReviewPhotoListPageResources = void 0;
var zod_1 = require("zod");
exports.LeisureReviewPhotoListPageResources = zod_1.z.object({
    productGroupId: zod_1.z.number(),
});
exports.LeisureReviewPhotoListPageQuery = zod_1.z.object({
    page: zod_1.z.number().optional(),
});
exports.LeisureReviewPhotoListPageRequestSchema = zod_1.z.object({
    resources: exports.LeisureReviewPhotoListPageResources,
    query: exports.LeisureReviewPhotoListPageQuery,
});
